/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import SubHeader from "../Components/SubHeader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

import {
  User,
  Mail,
  Phone,
  Calendar,
  Clock,
  CreditCard,
  Shield,
  Bell,
  Settings,
  Edit3,
  Save,
  X,
  Check,
  AlertCircle,
  Crown,
  Zap,
  RefreshCw,
  Eye,
  EyeOff,
  Camera,
  MapPin,
  Building2,
  Briefcase,
  Star,
  Award,
  Target,
  TrendingUp,
  Activity,
  Download,
  Upload,
  Lock,
  Unlock,
  ChevronRight,
  Plus,
  Minus,
  Gift,
  Heart,
  Car,
} from "lucide-react";
import Cookies from "js-cookie";

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {
        name: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        country: "",
        birthDate: "",
        profession: "",
        company: "",
        bio: "",
        profileImage: null,
        gender: "",
        referenceCode: "",
        points: 0,
        memberSince: "",
        // ustAltin: "",
      },

      editUserInfo: {
        isim: "",
        soyisim: "",
        phone: "",
        country: "",
        city: "",
        birthDate: "",
        profession: "",
        company: "",
        bio: "",
        gender: 1,
      },

      subscription: {
        plan: "Premium",
        status: "unknown",
        startDate: "—",
        endDate: "—",
        daysLeft: "—",
        autoRenew: true,
        price: "",
        features: ["7/24 destek"],
        nextPaymentDate: "01.01.2025",
        paymentMethod: "Kredi Kartı ****1234",
      },

      isSubmitting: false,
      activeTab: "profile",
      isUploading: false,

      stats: {
        totalAfis: 0,
        totalKatilim: 0,
        totalPoints: 0,
        memberSince: "",
        rating: 4.8,
      },

      successMessage: "",
      errorMessage: "",
      loading: true,
    };
  }
  // Üyelik ücreti panelden değişebildiği için sunucudan okunur.
  // Abonelik bilgisinden (get-info) bağımsız: o istek başarısız olsa da ücret görünür.
  uyelikUcretiGetir = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/posnet/uyelik-ucreti`
      );
      const result = await response.json();
      if (result.success) {
        this.setState((prev) => ({
          subscription: { ...prev.subscription, price: `${result.tl}₺` },
        }));
      }
    } catch (error) {
      console.error("Üyelik ücreti alınamadı:", error);
    }
  };

  // Gerçek üyelik tarihleri (eski /api/odeme/get-info kodda kapalıydı, sahte tarih gösteriliyordu)
  getSubDetails = async () => {
    let result;
    try {
      const request = await fetch(
        `${process.env.REACT_APP_API_URL}/api/yenile/uyelik-bilgisi`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: Cookies.get("token"),
          }),
        }
      );
      result = await request.json();
    } catch (error) {
      console.error("Üyelik bilgisi alınamadı:", error);
      return;
    }
    if (result.m !== "basarili") return;

    const startDate = result.baslangicMetin || "—";
    const endDate = result.bitisMetin || "—";
    // Bitiş geçtiyse eksi gün gösterme (ek süredeki üyeye "-3" yazıyordu)
    const daysLeft = typeof result.kalanGun === "number" ? Math.max(result.kalanGun, 0) : "—";
    // Durum /yenile ile aynı: aktif | ek_sure | suresi_doldu
    const status = result.durum === "aktif" ? "active" : result.durum === "ek_sure" ? "grace" : "expired";

    this.setState((prev) => ({
      subscription: {
        plan: "Premium",
        status,
        startDate: startDate,
        endDate: endDate,
        daysLeft: daysLeft,
        autoRenew: true,
        price: prev.subscription.price,
        features: ["7/24 destek"],
        nextPaymentDate: endDate,
        paymentMethod: "Kredi Kartı ****1234",
      },
    }));
  };

  componentDidMount() {
    this.loadUserData();
    this.loadUserStats();
    this.uyelikUcretiGetir();
    this.getSubDetails();
  }

  loadUserData = async () => {
    try {
      const token = Cookies.get("token") || localStorage.getItem("token");
      if (!token) {
        window.location.href = "/login";
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/userweb/getir`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        }
      );

      const data = await response.json();

      if (data.m === "basarili") {
        const userInfo = data.data;

        this.setState({
          userInfo: {
            name: userInfo.name,
            email: userInfo.email,
            phone: userInfo.phone,
            address: userInfo.address || "",
            city: userInfo.city,
            country: userInfo.country,
            birthDate: userInfo.birthDate,
            profession: userInfo.profession,
            company: userInfo.company,
            bio: userInfo.bio,
            profileImage: userInfo.profileImage,
            gender: userInfo.gender,
            referenceCode: userInfo.referenceCode,
            points: userInfo.points,
            memberSince: userInfo.memberSince,
            // ustAltin: userInfo.ustAltin,
          },
          editUserInfo: {
            isim: userInfo.name.split(" ")[0] || "",
            soyisim: userInfo.name.split(" ").slice(1).join(" ") || "",
            phone: userInfo.phone,
            country: userInfo.country,
            city: userInfo.city,
            birthDate: userInfo.birthDate,
            profession: userInfo.profession,
            company: userInfo.company,
            bio: userInfo.bio,
            gender: userInfo.gender === "Kadın" ? 1 : 0,
          },
          loading: false,
        });
      } else {
        this.setState({
          errorMessage: "Kullanıcı bilgileri yüklenirken hata oluştu.",
          loading: false,
        });
      }
    } catch (error) {
      this.setState({
        errorMessage: "Bağlantı hatası. Lütfen tekrar deneyin.",
        loading: false,
      });
    }
  };

  loadUserStats = async () => {
    try {
      const token = Cookies.get("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/userweb/istatistikler`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        }
      );

      const data = await response.json();

      if (data.m === "basarili") {
        this.setState({
          stats: data.data,
        });
      }
    } catch (error) {}
  };

  handleInputChange = (field, value) => {
    this.setState({
      editUserInfo: {
        ...this.state.editUserInfo,
        [field]: value,
      },
    });
  };

  // Yenileme /yenile sayfasında yapılır (web oturumu varsa orada otomatik giriş olur)
  renewSubscription = () => {
    window.location.href = "/yenile";
  };

  toggleAutoRenew = () => {
    this.setState({
      subscription: {
        ...this.state.subscription,
        autoRenew: !this.state.subscription.autoRenew,
      },
      successMessage: `Otomatik yenileme ${
        !this.state.subscription.autoRenew ? "açıldı" : "kapatıldı"
      }!`,
    });

    setTimeout(() => {
      this.setState({ successMessage: "" });
    }, 3000);
  };

  render() {
    const {
      userInfo,
      editUserInfo,
      subscription,
      isSubmitting,
      activeTab,
      stats,
      successMessage,
      errorMessage,
      loading,

      isUploading,
    } = this.state;

    if (loading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "#f8fafc",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #e2e8f0",
              borderTop: "4px solid #667eea",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
        </div>
      );
    }

    const getSubscriptionStatusColor = () => {
      switch (subscription.status) {
        case "active":
          return subscription.daysLeft > 30 ? "#10b981" : "#f59e0b";
        case "expiring":
        case "grace":
          return "#f59e0b";
        case "expired":
          return "#ef4444";
        case "cancelled":
          return "#6b7280";
        case "error":
          return "#6b7280";
        default:
          return "#6b7280";
      }
    };

    const getSubscriptionStatusText = () => {
      switch (subscription.status) {
        case "active":
          return subscription.daysLeft > 30
            ? "Aktif"
            : subscription.daysLeft > 7
            ? "Aktif"
            : "Yakında Bitecek";
        case "expiring":
          return "Yakında Bitecek";
        case "grace":
          return "Ek Süre";
        case "expired":
          return "Süresi Dolmuş";
        case "cancelled":
          return "İptal Edilmiş";
        case "error":
          return "Hata";
        default:
          return "Bilinmiyor";
      }
    };

    return (
      <>
        <SubHeader />
        <Header
          isLoggedIn={Cookies.get("token") != null}
          userName={userInfo.name}
        />

        <div style={{ background: "#f8fafc", minHeight: "100vh" }}>
          <div
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              padding: "80px 0 60px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                pointerEvents: "none",
              }}
            />

            <div
              className="container"
              style={{ position: "relative", zIndex: 1 }}
            >
              <div className="row">
                <div className="text-center">
                  <h6
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "14px",
                      fontWeight: "600",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginBottom: "15px",
                    }}
                  >
                    👤 PROFİL
                  </h6>
                  <h1
                    style={{
                      color: "white",
                      fontSize: "42px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      lineHeight: "1.2",
                    }}
                  >
                    Hesap Yönetimi
                  </h1>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontSize: "18px",
                      lineHeight: "1.6",
                      maxWidth: "800px",
                      margin: "0 auto",
                    }}
                  >
                    Profil bilgilerinizi, abonelik durumunuzu bu sayfadan
                    görüntüleyebilirsiniz.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {(successMessage || errorMessage) && (
            <div style={{ padding: "20px 0 0" }}>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div
                      style={{
                        background: successMessage
                          ? "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)"
                          : "linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)",
                        border: `1px solid ${
                          successMessage ? "#10b981" : "#ef4444"
                        }`,
                        borderRadius: "12px",
                        padding: "15px 20px",
                        color: successMessage ? "#065f46" : "#7f1d1d",
                        fontSize: "14px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    >
                      {successMessage ? (
                        <Check size={16} />
                      ) : (
                        <AlertCircle size={16} />
                      )}
                      {successMessage || errorMessage}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div style={{ padding: "30px 0 30px", background: "white" }}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div
                    style={{
                      background: "#f8fafc",
                      borderRadius: "16px",
                      padding: "8px",
                      display: "flex",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}
                  >
                    {[
                      { id: "profile", label: "👤 Profil" },
                      { id: "subscription", label: "💎 Abonelik" },
                      { id: "billing", label: "📄 Faturalarım" },
                    ].map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => {
                          if (tab.id === "billing") {
                            window.location.href = "/faturalarim";
                          } else {
                            this.setState({ activeTab: tab.id });
                          }
                        }}
                        style={{
                          background:
                            activeTab === tab.id
                              ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                              : "transparent",
                          color: activeTab === tab.id ? "white" : "#64748b",
                          border: "none",
                          borderRadius: "12px",
                          padding: "15px 25px",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          flex: "1",
                          minWidth: "150px",
                          boxShadow:
                            activeTab === tab.id
                              ? "0 8px 25px rgba(102, 126, 234, 0.3)"
                              : "none",
                        }}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "0 0 60px", background: "#f8fafc" }}>
            <div className="container">
              {activeTab === "profile" && (
                <div className="row">
                  <div className="col-lg-4 mb-40">
                    <div
                      className="universal-card universal-shimmer"
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                        borderRadius: "20px",
                        padding: "40px 30px",
                        textAlign: "center",
                        boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
                        border: "1px solid rgba(226, 232, 240, 0.5)",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <div
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "50%",
                            background: userInfo.profileImage
                              ? `url(${
                                  process.env.REACT_APP_API_URL
                                }/api/files/?filepath=${
                                  userInfo.profileImage
                                }&token=${Cookies.get("token")})`
                              : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            color: "white",
                            fontSize: "48px",
                            fontWeight: "700",
                            boxShadow: "0 15px 40px rgba(102, 126, 234, 0.3)",
                            position: "relative",
                          }}
                        >
                          {!userInfo.profileImage && userInfo.name.charAt(0)}
                        </div>
                      </div>

                      <h3
                        style={{
                          fontSize: "24px",
                          fontWeight: "700",
                          marginBottom: "10px",
                          color: "#1e293b",
                        }}
                      >
                        {userInfo.name}
                      </h3>

                      <p
                        style={{
                          color: "#64748b",
                          fontSize: "14px",
                          marginBottom: "20px",
                        }}
                      >
                        {userInfo.profession || "Kariyer belirtilmemiş"}
                      </p>

                      <div
                        style={{
                          background: "#f1f5f9",
                          borderRadius: "12px",
                          padding: "15px",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <span style={{ fontSize: "13px", color: "#64748b" }}>
                            Üyelik Süresi
                          </span>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.memberSince}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ fontSize: "13px", color: "#64748b" }}>
                            Puanım
                          </span>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.points}
                          </span>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                            padding: "8px 12px",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <Award size={14} />
                          Premium
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-8 mb-40">
                    <div
                      className="universal-card universal-shimmer"
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                        borderRadius: "20px",
                        padding: "40px",
                        boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
                        border: "1px solid rgba(226, 232, 240, 0.5)",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "30px",
                        }}
                      >
                        <h3
                          style={{
                            fontSize: "28px",
                            fontWeight: "700",
                            color: "#1e293b",
                            margin: 0,
                          }}
                        >
                          Profil Bilgileri
                        </h3>
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <User
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Ad
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.name.split(" ")[0] || "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <User
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Soyad
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.name.split(" ").slice(1).join(" ") ||
                              "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <Mail
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            E-Posta
                          </label>
                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.email}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <Phone
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Telefon
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.phone || "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <Calendar
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Doğum Tarihi
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.birthDate || "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <User
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Cinsiyet
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.gender || "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <Briefcase
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Kariyer
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.profession || "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <Building2
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Ekip
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.company || "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <MapPin
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Ülke
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.country || "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <MapPin
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Şehir
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.city || "Belirtilmemiş"}
                          </div>
                        </div>

                        <div className="col-12 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <User
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Hakkında / Kazanımlar
                          </label>

                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                              minHeight: "100px",
                              lineHeight: "1.6",
                            }}
                          >
                            {userInfo.bio || "Henüz bilgi girilmemiş"}
                          </div>
                        </div>
                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <Star
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Referans Kodu
                          </label>
                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.referenceCode || "Belirtilmemiş"}
                          </div>
                        </div>

                        {/* <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            <Crown
                              size={16}
                              style={{
                                marginRight: "8px",
                                verticalAlign: "middle",
                              }}
                            />
                            Üst Altın
                          </label>
                          <div
                            style={{
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              background: "#f8fafc",
                              color: "#1e293b",
                            }}
                          >
                            {userInfo.ustAltin || "Belirtilmemiş"}
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-12">
                    <div className="row">
                      <div className="col-lg-3 col-md-6 mb-30">
                        <div
                          className="universal-card stats-card"
                          style={{
                            background:
                              "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            borderRadius: "20px",
                            padding: "30px",
                            textAlign: "center",
                            boxShadow: "0 20px 60px rgba(102, 126, 234, 0.3)",
                            border: "none",
                            color: "white",
                          }}
                        >
                          <Target size={40} style={{ marginBottom: "15px" }} />
                          <h3
                            style={{
                              fontSize: "32px",
                              fontWeight: "700",
                              marginBottom: "5px",
                            }}
                          >
                            {stats.totalAfis}
                          </h3>
                          <p
                            style={{
                              fontSize: "14px",
                              opacity: 0.9,
                              margin: 0,
                            }}
                          >
                            Toplam Afişim
                          </p>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6 mb-30">
                        <div
                          className="universal-card stats-card"
                          style={{
                            background:
                              "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                            borderRadius: "20px",
                            padding: "30px",
                            textAlign: "center",
                            boxShadow: "0 20px 60px rgba(16, 185, 129, 0.3)",
                            border: "none",
                            color: "white",
                          }}
                        >
                          <Heart size={40} style={{ marginBottom: "15px" }} />
                          <h3
                            style={{
                              fontSize: "32px",
                              fontWeight: "700",
                              marginBottom: "5px",
                            }}
                          >
                            {stats.totalKatilim}
                          </h3>
                          <p
                            style={{
                              fontSize: "14px",
                              opacity: 0.9,
                              margin: 0,
                            }}
                          >
                            Katıldığım Afiş
                          </p>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6 mb-30">
                        <div
                          className="universal-card stats-card"
                          style={{
                            background:
                              "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                            borderRadius: "20px",
                            padding: "30px",
                            textAlign: "center",
                            boxShadow: "0 20px 60px rgba(245, 158, 11, 0.3)",
                            border: "none",
                            color: "white",
                          }}
                        >
                          <Zap size={40} style={{ marginBottom: "15px" }} />
                          <h3
                            style={{
                              fontSize: "32px",
                              fontWeight: "700",
                              marginBottom: "5px",
                            }}
                          >
                            {stats.totalPoints}
                          </h3>
                          <p
                            style={{
                              fontSize: "14px",
                              opacity: 0.9,
                              margin: 0,
                            }}
                          >
                            Toplam Puanım
                          </p>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6 mb-30">
                        <div
                          className="universal-card stats-card"
                          style={{
                            background:
                              "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                            borderRadius: "20px",
                            padding: "30px",
                            textAlign: "center",
                            boxShadow: "0 20px 60px rgba(139, 92, 246, 0.3)",
                            border: "none",
                            color: "white",
                          }}
                        >
                          <Star size={40} style={{ marginBottom: "15px" }} />
                          <h3
                            style={{
                              fontSize: "32px",
                              fontWeight: "700",
                              marginBottom: "5px",
                            }}
                          >
                            {stats.rating}
                          </h3>
                          <p
                            style={{
                              fontSize: "14px",
                              opacity: 0.9,
                              margin: 0,
                            }}
                          >
                            Ortalama Puan
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              )}

              {activeTab === "subscription" && (
                <div className="row">
                  <div className="col-lg-8 mb-40">
                    <div
                      className="universal-card universal-shimmer"
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                        borderRadius: "20px",
                        padding: "40px",
                        boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
                        border: "1px solid rgba(226, 232, 240, 0.5)",
                        marginBottom: "30px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "30px",
                        }}
                      >
                        <div>
                          <h3
                            style={{
                              fontSize: "28px",
                              fontWeight: "700",
                              color: "#1e293b",
                              marginBottom: "5px",
                            }}
                          >
                            💎 {subscription.plan} Abonelik
                          </h3>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                              background: getSubscriptionStatusColor(),
                              color: "white",
                              padding: "6px 12px",
                              borderRadius: "20px",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            <div
                              style={{
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                background: "white",
                              }}
                            />
                            {getSubscriptionStatusText()}
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div
                            style={{
                              fontSize: "32px",
                              fontWeight: "700",
                              color: "#1e293b",
                              lineHeight: "1",
                            }}
                          >
                            {subscription.price}
                          </div>
                          <div style={{ fontSize: "14px", color: "#64748b" }}>
                            /yıllık
                          </div>
                        </div>
                      </div>

                      <div className="row mb-30">
                        <div className="col-md-3 mb-20">
                          <div
                            style={{
                              background: "#f1f5f9",
                              borderRadius: "12px",
                              padding: "20px",
                              textAlign: "center",
                            }}
                          >
                            <Calendar
                              size={24}
                              style={{ color: "#667eea", marginBottom: "10px" }}
                            />
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#64748b",
                                marginBottom: "5px",
                              }}
                            >
                              Başlangıç
                            </div>
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#1e293b",
                              }}
                            >
                              {subscription.startDate}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-3 mb-20">
                          <div
                            style={{
                              background: "#f1f5f9",
                              borderRadius: "12px",
                              padding: "20px",
                              textAlign: "center",
                            }}
                          >
                            <Clock
                              size={24}
                              style={{ color: "#f59e0b", marginBottom: "10px" }}
                            />
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#64748b",
                                marginBottom: "5px",
                              }}
                            >
                              Bitiş
                            </div>
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#1e293b",
                              }}
                            >
                              {subscription.endDate}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-3 mb-20">
                          <div
                            style={{
                              background:
                                subscription.daysLeft > 30
                                  ? "#ecfdf5"
                                  : "#fef3c7",
                              borderRadius: "12px",
                              padding: "20px",
                              textAlign: "center",
                            }}
                          >
                            <Target
                              size={24}
                              style={{
                                color:
                                  subscription.daysLeft > 30
                                    ? "#10b981"
                                    : "#f59e0b",
                                marginBottom: "10px",
                              }}
                            />
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#64748b",
                                marginBottom: "5px",
                              }}
                            >
                              Kalan Gün
                            </div>
                            <div
                              style={{
                                fontSize: "18px",
                                fontWeight: "700",
                                color:
                                  subscription.daysLeft > 30
                                    ? "#10b981"
                                    : "#f59e0b",
                              }}
                            >
                              {subscription.daysLeft}
                            </div>
                          </div>
                        </div>

                        {/* <div className="col-md-3 mb-20">
                          <div
                            style={{
                              background: "#f1f5f9",
                              borderRadius: "12px",
                              padding: "20px",
                              textAlign: "center",
                            }}
                          >
                            <CreditCard
                              size={24}
                              style={{ color: "#667eea", marginBottom: "10px" }}
                            />
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#64748b",
                                marginBottom: "5px",
                              }}
                            >
                              Sonraki Ödeme
                            </div>
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#1e293b",
                              }}
                            >
                              {subscription.nextPaymentDate}
                            </div>
                          </div>
                        </div> */}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "15px",
                          flexWrap: "wrap",
                        }}
                      >
                        <button
                          onClick={this.renewSubscription}
                          disabled={isSubmitting}
                          className="universal-button"
                          style={{
                            background: isSubmitting
                              ? "#94a3b8"
                              : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            color: "white",
                            padding: "15px 30px",
                            border: "none",
                            borderRadius: "12px",
                            fontSize: "14px",
                            fontWeight: "600",
                            cursor: isSubmitting ? "not-allowed" : "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: isSubmitting
                              ? "none"
                              : "0 8px 25px rgba(102, 126, 234, 0.3)",
                          }}
                        >
                          {isSubmitting ? (
                            <>
                              <div
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  border: "2px solid #ffffff",
                                  borderTop: "2px solid transparent",
                                  borderRadius: "50%",
                                  animation: "spin 1s linear infinite",
                                }}
                              />
                              Yenileniyor...
                            </>
                          ) : (
                            <>
                              <RefreshCw size={16} />
                              Aboneliği Yenile
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 mb-40">
                    <div
                      className="universal-card universal-shimmer"
                      style={{
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                        borderRadius: "20px",
                        padding: "30px",
                        boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
                        border: "1px solid rgba(226, 232, 240, 0.5)",
                        marginBottom: "20px",
                      }}
                    >
                      <h4
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#1e293b",
                          marginBottom: "20px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Crown size={20} style={{ color: "#f59e0b" }} />
                        Premium Özellikler
                      </h4>

                      <div style={{ marginBottom: "25px" }}>
                        {subscription.features.map((feature, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              padding: "12px 0",
                              borderBottom:
                                index < subscription.features.length - 1
                                  ? "1px solid #f1f5f9"
                                  : "none",
                            }}
                          >
                            <div
                              style={{
                                background:
                                  "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                              }}
                            >
                              <Check size={12} style={{ color: "white" }} />
                            </div>
                            <span
                              style={{ fontSize: "14px", color: "#374151" }}
                            >
                              {feature}
                            </span>
                          </div>
                        ))}
                      </div>

                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                          borderRadius: "12px",
                          padding: "20px",
                          textAlign: "center",
                        }}
                      >
                        <Crown
                          size={24}
                          style={{ color: "#f59e0b", marginBottom: "10px" }}
                        />
                        <h5
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#92400e",
                            marginBottom: "8px",
                          }}
                        >
                          Özel İndirim!
                        </h5>
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#92400e",
                            margin: 0,
                          }}
                        >
                          Web Sitesinden Alımda tasarruf edin
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <style jsx>{`
            @keyframes spin {
              0% {
                transform: rotate(0deg);
              }
              100% {
                transform: rotate(360deg);
              }
            }

            .universal-card {
              cursor: pointer;
              transition: all 0.3s ease;
              will-change: transform, box-shadow;
              backface-visibility: hidden;
              perspective: 1000px;
              flex: 1;
              display: flex;
              flex-direction: column;
              transform: translateY(0);
            }

            .universal-card:hover {
              transform: translateY(-8px) translateZ(0);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12) !important;
            }

            .universal-icon {
              transition: transform 0.25s ease;
              will-change: transform;
            }

            .universal-card:hover .universal-icon {
              transform: scale(1.05) translateZ(0);
            }

            .universal-button {
              transition: transform 0.25s ease, box-shadow 0.25s ease;
              position: relative;
              overflow: hidden;
              will-change: transform, box-shadow;
            }

            .universal-button:before {
              content: "";
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.2),
                transparent
              );
              transition: left 0.4s ease;
            }

            .universal-card:hover .universal-button:before {
              left: 100%;
            }

            .universal-card:hover .universal-button {
              transform: translateY(-2px) translateZ(0);
              box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3) !important;
            }

            .universal-pattern {
              transition: opacity 0.3s ease;
            }

            .universal-card:hover .universal-pattern {
              opacity: 1.2;
            }

            .universal-shimmer {
              position: relative;
              overflow: hidden;
            }

            .universal-shimmer:before {
              content: "";
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.3),
                transparent
              );
              transition: left 0.6s ease;
            }

            .universal-card:hover .universal-shimmer:before {
              left: 100%;
            }

            .stats-card:hover {
              transform: translateY(-12px) translateZ(0);
              box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15) !important;
            }

            .row {
              margin-left: -15px;
              margin-right: -15px;
            }

            .col-lg-3,
            .col-lg-4,
            .col-lg-6,
            .col-lg-8,
            .col-md-3,
            .col-md-6,
            .col-12 {
              padding-left: 15px;
              padding-right: 15px;
            }

            .mb-30 {
              margin-bottom: 30px;
            }
            .mb-40 {
              margin-bottom: 40px;
            }
            .mb-20 {
              margin-bottom: 20px;
            }
            .mb-25 {
              margin-bottom: 25px;
            }

            .text-center {
              text-align: center;
            }
            .offset-lg-2 {
              margin-left: 16.666667%;
            }

            @media (max-width: 768px) {
              .row {
                margin-left: -10px;
                margin-right: -10px;
              }

              .col-lg-3,
              .col-lg-4,
              .col-lg-6,
              .col-lg-8,
              .col-md-3,
              .col-md-6,
              .col-12 {
                padding-left: 10px;
                padding-right: 10px;
              }

              .mb-30 {
                margin-bottom: 25px;
              }
              .mb-40 {
                margin-bottom: 30px;
              }

              .universal-card:hover {
                transform: translateY(-4px) translateZ(0);
              }

              .stats-card:hover {
                transform: translateY(-6px) translateZ(0);
              }

              .offset-lg-2 {
                margin-left: 0;
              }
            }

            .universal-card,
            .universal-icon,
            .universal-button {
              transform: translateZ(0);
            }
          `}</style>
        </div>

        <Footer />
      </>
    );
  }
}
